import React from "react";
import Typography from "@mui/material/Typography";
import MuiLink from "@mui/material/Link";
import { SxProps } from "@mui/material";

import { neutral } from "../../../config/colors";

const TermsAndPrivacyText: React.FC<{
  startText?: string;
  typographySxProps?: SxProps;
}> = ({
  startText = "By registering up you agree to our",
  typographySxProps,
}) => {
  return (
    <Typography
      fontSize={12}
      color={neutral[400]}
      sx={{ ...(typographySxProps || {}) }}
    >
      {startText}{" "}
      <MuiLink href="/terms-of-service" target="_blank" underline="none">
        Terms of Service
      </MuiLink>{" "}
      and{" "}
      <MuiLink href="/privacy-policy" target="_blank" underline="none">
        Privacy Policy
      </MuiLink>
    </Typography>
  );
};

export default TermsAndPrivacyText;
